import { createFileRoute } from '@tanstack/react-router';

import { MeasurePage } from '@/features/commercial/measure-page';

export const Route = createFileRoute('/_app/projects/$projectId/commercial/measure/$valuationId')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId, valuationId } = Route.useParams();
  return <MeasurePage projectId={projectId} valuationId={valuationId} />;
}
